var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"checkbox"},domProps:{"checked":parseInt(_vm.params.value)},on:{"click":function($event){return _vm.checkedHandler($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }